import { type ReactElement, useMemo } from 'react';
import { useRouter } from 'next/router';
import Select, { ISelectOption } from '@creditflowresearch/uilib/Select';
import { removeQueryParams } from '@framework/router';
import { useStatsContext } from '@/creditflowresearch/application/ArticlesAndStats/Stats/StatsContext';
import { getCategoryUrl } from '../helpers';
import { IQueryParams } from '@/creditflowresearch/domain/vo/IQueryParams';

const ALL_OPTION: ISelectOption = { label: 'All', value: 'all' };

const CategoriesSelect = (): ReactElement => {
  const { push, query: routeParams } = useRouter();
  const { categories } = useStatsContext();
  const { categoryId } = routeParams;

  const query = useMemo<IQueryParams>(
    () => removeQueryParams(routeParams, ['categoryId']),
    [routeParams],
  );

  const options: ISelectOption[] = useMemo(
    () => [ALL_OPTION, ...categories.map(({ id, name }) => ({ label: name, value: id }))],
    [categories],
  );

  const value = useMemo(
    () => options.find((option) => option.value === categoryId) || ALL_OPTION,
    [options, categoryId],
  );

  const handleChange = (option: ISelectOption): void => {
    push(getCategoryUrl(option.value as string, query), undefined, { shallow: true });
  };

  return (
    <Select
      value={ value }
      options={ options }
      onChange={ handleChange }
      isNarrow
      isSearchable={ false }
      dataTest="categoriesSelect"
    />
  );
};

export default CategoriesSelect;
